import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SwHeader from './components/SwHeader';
import SwHero from './components/SwHero';
import SwSearchWidget from './components/SwSearchWidget';
import SwArticle from './components/SwArticle';
import SwFaq from './components/SwFaq';
import SwFooter from './components/SwFooter';
import SwCallBar from './components/SwCallBar';
import { AirlineLandingProvider, useAirlineLanding } from './AirlineContext';
import { airlineThemeClass, getAirlineBySlug } from './airlines';
import './southwest.css';
import './airline-themes.css';

function AirlineLandingInner() {
  const { meta, airline } = useAirlineLanding();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = meta.title;

    const metaEl = document.querySelector('meta[name="description"]');
    const previousDescription = metaEl?.getAttribute('content') ?? null;
    metaEl?.setAttribute('content', meta.description);

    document.body.classList.add('swp-standalone');

    return () => {
      document.title = previousTitle;
      if (metaEl && previousDescription !== null) metaEl.setAttribute('content', previousDescription);
      document.body.classList.remove('swp-standalone');
    };
  }, [meta]);

  return (
    <div className={airlineThemeClass('swp', airline)}>
      <SwHeader />
      <main>
        <SwHero />
        <SwSearchWidget />
        <SwArticle />
        <SwFaq />
      </main>
      <SwFooter />
      <SwCallBar />
    </div>
  );
}

/**
 * Standalone airline landing page. It does not use the main site header, footer,
 * routing links, styles, or constants — everything it needs lives in this folder.
 */
export default function AirlineLandingPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  if (!getAirlineBySlug(slug)) return null;

  return (
    <AirlineLandingProvider slug={slug}>
      <AirlineLandingInner />
    </AirlineLandingProvider>
  );
}
